import * as React from 'react';
import { FC, useCallback } from 'react';

import { Linking } from 'react-native';

import { t } from 'state/intl/translations';
import { fullBrandName } from 'utils/environment';

import { AdsPersonalizationDeniedModalView } from './ads-personalization-denied-modal.view';
import { IAdsPersonalizationDeniedModalProps } from './types';

const FULL_BRAND_NAME = fullBrandName();

/**
 * Shown when a user tries to enable Interest-Based Advertising but App Tracking Transparency
 * is denied at the OS level. Apple does not allow an app to re-prompt or flip that permission
 * itself (see docs/adr/0001-interest-based-advertising-is-a-ceiling-gated-opt-out.md), so this
 * directs the user to system Settings instead of silently failing, mirroring
 * components/geolocation-denied-modal's existing pattern for a denied OS permission.
 */
export const AdsPersonalizationDeniedModal: FC<React.PropsWithChildren<
  IAdsPersonalizationDeniedModalProps
>> = ({ isOpen, dismissModal }) => {
  const openSettings = useCallback(async () => {
    await Linking.openSettings();
  }, []);

  return (
    <AdsPersonalizationDeniedModalView
      dismissModal={dismissModal}
      isOpen={isOpen}
      modalBodyText={t('updateDeviceTrackingSettings', { brand: FULL_BRAND_NAME })}
      modalHeadingText={t('enableTrackingPermission')}
      openSettings={openSettings}
      openSettingsButtonText={t('deviceSettings')}
    />
  );
};
